export { errorMessage, initials, personName } from '../../customers/common/customer-common'

export const MY_ACCOUNT_BACK_PATH = '/configuracion'

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}
